export default __webpack_public_path__ + "static/media/11-1_file.89ed3937.svg";